export enum ReportReason {
	None = '',
	FakeListing = 'Fake listing',
	Inaccurate = 'Inaccurate listing',
	Phishing = 'Phishing or suspicious messages',
	Safety = 'Safety concerns',
	Private = 'Landlord wants to do a private deal and exclude DigsConnect',
	Other = 'Other',
}
